import ThreeDView from './ThreeDView';

export default ThreeDView;
